import axios from "./axios";

export const getAll = () => {
  return axios.get('api/settings/help-page');
};

export const getWhere = (where, sort = '', limit = 100, offset = 0) => {
  // settings
  return axios.get('api/settings/help-page');
};
